export const getUnreadCount = (state: App.State): number => {
  return state.supportAssistant.unreadMessageCount || 0
}
